/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { NavigationItem } from '@squiz/sds';
import cloneDeep from 'lodash/cloneDeep';
import { EntityDxpUserMeOrganisation } from '../../Services/console';
import { checkScreenCondition } from '../CheckScreenCondition/CheckScreenCondition';

/**
 * Process the navigation item for necessary updates and checks.
 * @returns A navigation item with applied checks.
 */
export const processNavItems = (
  tenantReferenceId: EntityDxpUserMeOrganisation['tenantReferenceId'],
  navItem: NavigationItem,
): NavigationItem | null => {
  // Create copy of the current object
  const clone = cloneDeep(navItem);

  const shouldDisplay = checkScreenCondition(clone);
  if (!shouldDisplay) {
    return null;
  }

  if (clone.children?.length) {
    const updatedChildren: Array<NavigationItem> = [];

    clone.children.forEach((childNavItem) => {
      const newChildNavItem = processNavItems(tenantReferenceId, childNavItem);
      if (newChildNavItem) {
        updatedChildren.push(newChildNavItem);
      }
    });

    if (updatedChildren.length) {
      clone.children = updatedChildren;
    } else {
      delete clone.children;
    }
  }

  // Update item path with actual tenant reference ID.
  return {
    ...clone,
    path: navItem.path.replace(/:tenant/, tenantReferenceId),
  };
};
